const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	lista: [],
	listaEstoqueLocal: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'CLIENTE_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

        case 'CLIENTE_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

        case 'CLIENTE_ESTOQUE_LOCAL_SELECT_LISTADO':
			return {
				...state,
				listaEstoqueLocal: action.payload.data
			};

        default:
            return state;
    }
}
